import logo from './logo.svg';
import './App.css';
import './update.css'
// import { Route, Routes } from "react-router-dom";
import HomePage from './components/HomePage';
import Home from './components/Home';
import Achievement from './components/Achievement';
import About from './components/About';
import NavBar from './components/NavBar';
import IntroPage from './components/IntroPage';
import ProjectWrapper from './components/ProjectWrapper';
import ContactWrapper from './components/ContactWrapper';
import Skills from './components/Skills';
import Experience from './components/Experience';

function App() {
  return (
    <div className="App">
      <NavBar></NavBar>
      <IntroPage></IntroPage>
      <About></About>
      <Experience/>
      <Achievement></Achievement>
      <Skills></Skills>
      <ProjectWrapper></ProjectWrapper>
      <ContactWrapper></ContactWrapper>
    </div>
  );
}

export default App;
